
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mentions-legales",
      function () {
        return require("private-next-pages/mentions-legales.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mentions-legales"])
      });
    }
  